var App = App || {};

App.ApplicationModal = (function ($) {
    'use strict';

    function init() {
        $('a').each(function () {
            if ($(this).parents(".modal").length == 0) {
                var $this = $(this),
                    url = $this.attr('href');

                if (this.hostname !== location.hostname
                    && url
                    && url.indexOf('#') !== 0
                    && (url.indexOf("loanspq") !== -1 && url.indexOf("/pl/PersonalLoan") !== -1)
                    && !$this.hasClass("no-modal")) {

                    $(this).attr("data-bs-toggle", "modal").attr("data-bs-target", "#Modal-personalSpeedbumpModal");
                }

                if (this.hostname !== location.hostname
                    && url
                    && url.indexOf('#') !== 0
                    && (url.indexOf("loanspq") !== -1 && url.indexOf("/vl/VehicleLoan") !== -1)
                    && !$this.hasClass("no-modal")) {

                    $(this).attr("data-bs-toggle", "modal").attr("data-bs-target", "#Modal-vehicleSpeedbumpModal");
                }

                if (this.hostname !== location.hostname
                    && url
                    && url.indexOf('#') !== 0
                    && (url.indexOf("loanspq") !== -1 && url.indexOf("/cc/CreditCard") !== -1)
                    && !$this.hasClass("no-modal")) {

                    $(this).attr("data-bs-toggle", "modal").attr("data-bs-target", "#Modal-ccSpeedbumpModal");
                }

                if (this.hostname !== location.hostname
                    && url
                    && url.indexOf('#') !== 0
                    && (url.indexOf("loanspq") !== -1 && url.indexOf("/he/HomeEquityLoan") !== -1)
                    && !$this.hasClass("no-modal")) {

                    $(this).attr("data-bs-toggle", "modal").attr("data-bs-target", "#Modal-homeSpeedbumpModal");
                }

                if (this.hostname !== location.hostname
                    && url
                    && url.indexOf('#') !== 0
                    && (url.indexOf("loanspq") !== -1 && url.indexOf("/apply") !== -1)
                    && !$this.hasClass("no-modal")) {

                    $(this).attr("data-bs-toggle", "modal").attr("data-bs-target", "#Modal-depositSpeedbumpModal");
                }
            }

        });

        $("a").on("click", function () {
            var $this = $(this),
                url = $this.attr('href');

            if (typeof url !== 'undefined' && url !== false && !$this.hasClass("no-modal") && !$this.hasClass("modal-btn")) {

                if (this.hostname !== location.hostname
                    && url
                    && url.indexOf('#') !== 0
                    && (url.indexOf("meridianlink") !== -1 || url.indexOf("loanspq") !== -1)
                    && !$this.hasClass("no-modal")) {

                    var modal = $(this).attr("data-bs-target");

                    $(modal).find(".application-modal__wrapper .application-modal__content-wrapper .application-modal__cta .modal-btn.btn-continue").attr('href', url);
                }
            }
        });

        $('.component-application-modal').each(function () {
            $(this).parents(".site-modals-custom").addClass("application-modal");
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ApplicationModal.init();
});